import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import {
  MatCard,
  MatCardHeader,
  MatCardContent,
  MatCardActions,
  MatCardTitle,
} from '@angular/material/card';
import { ViIconComponent } from '@vi-iot/ui/index';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-room-mode-modal',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    MatCard,
    MatCardHeader,
    MatCardContent,
    MatCardActions,
    MatCardTitle,
    ViIconComponent,
    MatIcon,
    MatButtonModule,
    MatDialogModule,
  ],
  templateUrl: './room-mode-modal.component.html',
  styleUrl: './room-mode-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomModeModalComponent {
  data: { header: string; text: string; icon: string }[] = [
    {
      header: '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE_MODAL.HEATING_HEADER',
      text: '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE_MODAL.HEATING_TEXT',
      icon: 'heating',
    },
    {
      header: '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE_MODAL.COOLING_HEADER',
      text: '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE_MODAL.COOLING_TEXT',
      icon: 'cooling',
    },
    {
      header: '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE_MODAL.HEATING_COOLING_HEADER',
      text: '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE_MODAL.HEATING_COOLING_TEXT',
      icon: 'temperature',
    },
    {
      header: '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE_MODAL.STANDBY_HEADER',
      text: '+INSTALLATIONS.INSTALLATION.SRC.ROOM_CONTROL_MODE_MODAL.STANDBY_TEXT',
      icon: 'pause',
    },
  ];
}
